module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-400italic.woff2?ac1612e21731e1a027139bd574ecf5e5";